// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { SummaryQrCodeRequest } from "../schema";

export function serialize_SummaryQrCodeRequest_internal(value: SummaryQrCodeRequest): unknown {
  return ((value: { dataId: bigint }): unknown => {
    return {
      dataId: ((value: bigint): unknown => {
        return value;
      })(value["dataId"]),
    };
  })(value);
}
export function serialize_SummaryQrCodeRequest(obj: SummaryQrCodeRequest): string {
  return renderJsonWithNumbersAsBigint(serialize_SummaryQrCodeRequest_internal(obj));
}
export function deserialize_SummaryQrCodeRequest_internal(value: unknown): ParserResult<SummaryQrCodeRequest> {
  return ((
    value: unknown,
  ): ParserResult<{
    dataId: bigint;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeRequest]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeRequest]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "dataId")) {
      return { success: false, reason: `[#/components/schemas/SummaryQrCodeRequest/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
    }
    const parsed_dataId = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryQrCodeRequest/dataId]: '${value}' expected to be of type bigint or number.` };
      })(value["dataId"]);
    })();
    if (!parsed_dataId.success) {
      return { success: false, reason: parsed_dataId.reason };
    }
    return { success: true, value: { dataId: parsed_dataId.value } };
  })(value);
}
export function deserialize_SummaryQrCodeRequest(str: string): ParserResult<SummaryQrCodeRequest> {
  return deserialize_SummaryQrCodeRequest_internal(parseJsonWithNumbersAsBigint(str));
}
